import {
  ReportingImportNormalizationIssueCandidatePayload,
  ReportingImportNormalizationMatchMode,
} from '../reporting/reporting-import.model';

export enum SearchReportingImportNormalizationResolutionOptionsRequestKeys {
  runId = 'runId',
  uploadActionId = 'uploadActionId',
  issueId = 'issueId',
}

export interface SearchReportingImportNormalizationResolutionOptionsRequest {
  [SearchReportingImportNormalizationResolutionOptionsRequestKeys.runId]?: string | null;
  [SearchReportingImportNormalizationResolutionOptionsRequestKeys.uploadActionId]?: string | null;
  [SearchReportingImportNormalizationResolutionOptionsRequestKeys.issueId]: string;
}

export enum SearchReportingImportNormalizationResolutionOptionsResponseKeys {
  issueId = 'issueId',
  matchMode = 'matchMode',
  suggestedValue = 'suggestedValue',
  options = 'options',
}

export interface SearchReportingImportNormalizationResolutionOptionsResponse {
  [SearchReportingImportNormalizationResolutionOptionsResponseKeys.issueId]: string;
  [SearchReportingImportNormalizationResolutionOptionsResponseKeys.matchMode]: ReportingImportNormalizationMatchMode | null;
  [SearchReportingImportNormalizationResolutionOptionsResponseKeys.suggestedValue]: string | null;
  [SearchReportingImportNormalizationResolutionOptionsResponseKeys.options]: ReportingImportNormalizationIssueCandidatePayload[];
}
